import React from "react";
import Icon, { QuestionCircleOutlined, ShopOutlined, TruckOutlined, UserOutlined } from "@ant-design/icons";

// Material's "business" building, as on the Android app's B2B avatar.
const BusinessSvg = () => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />
  </svg>
);
export const BusinessOutlined = props => <Icon component={BusinessSvg} {...props} />;

// Blue belongs to suppliers, so no customer type uses it.
export const SUPPLIER_AVATAR_COLOR = "#2f6bd8";
const CUSTOMER_TYPE_LOOKS = {
  0: { Icon: BusinessOutlined, color: "#c41d7f", label: "B2B" },
  1: { Icon: UserOutlined, color: "#753dc2", label: "B2C" },
  2: { Icon: TruckOutlined, color: "#277a62", label: "Fleet" },
};
const UNSET_LOOK = { Icon: QuestionCircleOutlined, color: "#c5871c", label: null };

// A customer's avatar icon and colour by their type (B2B 0, B2C 1, Fleet 2).
export function customerTypeLook(type) {
  const look = CUSTOMER_TYPE_LOOKS[type] || UNSET_LOOK;
  return { ...look, icon: <look.Icon /> };
}

export const supplierLook = () => ({ Icon: ShopOutlined, icon: <ShopOutlined />, color: SUPPLIER_AVATAR_COLOR, label: "Supplier" });
